export default "__VITE_PUBLIC_ASSET__4461551c__"